import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { TabsLoader } from './common/tabs-loader';

export const CloudSitePageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader hideActions />
      <TabsLoader />
      <br />
      <TableLoader />
    </div>
  );
};
